import {
  countWordsFromManuscriptContent,
  normalizeManuscriptContent,
  plainTextFromManuscriptContent,
} from "./childrensBookManuscriptContent";


function safeObject(
  value
) {
  return (
    value &&
    typeof value ===
      "object" &&
    !Array.isArray(
      value
    )
  )
    ? value
    : null;
}


function hasOwn(
  value,
  key
) {
  return Boolean(
    value &&
    Object.prototype
      .hasOwnProperty.call(
        value,
        key
      )
  );
}


function previewContractError(
  location,
  errors = []
) {
  const detail =
    (
      Array.isArray(errors)
        ? errors
        : []
    )
      .filter(Boolean)
      .join(" ");

  const error =
    new Error(
      detail
        ? `The Word manuscript contains formatting that could not be represented safely in ${location}. ${detail}`
        : `The Word manuscript contains formatting that could not be represented safely in ${location}.`
    );

  error.code =
    "MANUSCRIPT_CONTENT_INVALID";

  return error;
}


function normalizeStructuredOwner(
  value,
  location,
  {
    textKey = "",
    wordCountKey = "",
  } = {}
) {
  const source =
    safeObject(
      value
    );

  if (!source) {
    throw previewContractError(
      location
    );
  }

  if (
    !hasOwn(
      source,
      "manuscriptContent"
    )
  ) {
    return {
      ...source,
    };
  }

  const result =
    normalizeManuscriptContent(
      source.manuscriptContent
    );

  if (
    !result.ok ||
    !result.content
  ) {
    throw previewContractError(
      location,
      result.errors
    );
  }

  const projectedText =
    plainTextFromManuscriptContent(
      result.content
    );

  const normalizedOwner = {
    ...source,

    manuscriptContent:
      result.content,
  };

  if (textKey) {
    normalizedOwner[textKey] =
      projectedText;
  }

  if (wordCountKey) {
    normalizedOwner[wordCountKey] =
      countWordsFromManuscriptContent(
        result.content
      );
  }

  return normalizedOwner;
}


export function normalizeChildrensBookManuscriptImportPreview(
  value
) {
  const source =
    safeObject(
      value
    );

  if (
    !source ||
    !Array.isArray(
      source.sections
    )
  ) {
    throw previewContractError(
      "the preview response"
    );
  }

  const normalizedPreview =
    normalizeStructuredOwner(
      source,
      "the manuscript preview",
      {
        textKey:
          "manuscriptText",

        wordCountKey:
          "wordCount",
      }
    );

  return {
    ...normalizedPreview,

    sections:
      source.sections.map(
        (
          section,
          index
        ) =>
          normalizeStructuredOwner(
            section,
            `section ${index + 1}`,
            {
              textKey:
                "text",

              wordCountKey:
                "wordCount",
            }
          )
      ),
  };
}


export function normalizeChildrensBookManuscriptImportPreviewResponse(
  value
) {
  const source =
    safeObject(
      value
    );

  if (!source) {
    throw previewContractError(
      "the preview response"
    );
  }

  return {
    ...source,

    preview:
      normalizeChildrensBookManuscriptImportPreview(
        source.preview
      ),
  };
}
